import { getLanguage, Language } from '@/shared/lib/i18n';
import { shiftOptions } from '../../DialogContext/modals/EnrichVacancyModal/utils/EnrichVacancyModal.constants';

export const extractShifts = (shifts: string | undefined): string | undefined => {
  if (!shifts) return undefined;

  const language = getLanguage();

  return shifts
    .split(',')
    .map((shift) => replaceOrKeep(shift.trim(), language).trim())
    .join(', ');
};

const replaceOrKeep = (shift: string, language: Language): string => {
  const shiftOption = shiftOptions.find((option) => option.value === shift);
  if (shiftOption) return shiftOption.label[language];

  return shift;
};
